import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({
  mode: "light",
  setMode: () => {},
  toggleMode: () => {},
});

export const ThemeProviderCustom = ({ children }) => {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem("theme") || "light";
    } catch {
      return "light";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("theme", mode);
    } catch {
      /* ignore */
    }
    document.documentElement.classList.toggle("dark", mode === "dark");
    document.documentElement.setAttribute("data-theme", mode);
  }, [mode]);

  const toggleMode = () =>
    setMode((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <ThemeContext.Provider value={{ mode, setMode, toggleMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeContext);
